import React, { createContext, useEffect, useState } from 'react';
import api from '../../utils/axiosConfig';

export const SlideContext = createContext();

export const SlideProvider = ({ children }) => {
  const [slides, setSlides] = useState([]);

  // İlk yüklemede backend'den slaytları çek
  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await api.get('/api/slide');
        setSlides(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error('Slaytları yükleme hatası:', err);
        setSlides([]);
      }
    };
    fetchSlides();
  }, []);

  // Slayt ekle (backend'e POST)
  const addSlide = async (newSlide) => {
    try {
      const response = await api.post('/api/slide', newSlide);
      setSlides((prevSlides) => [...prevSlides, response.data]);
    } catch (err) {
      console.error('Slayt ekleme hatası:', err);
      throw err;
    }
  };

  // Slayt sil (backend'e DELETE)
  const removeSlide = async (index, id) => {
    try {
      await api.delete('/api/slide', { data: { id } });
      setSlides((prevSlides) => prevSlides.filter((_, i) => i !== index));
    } catch (err) {
      console.error('Slayt silme hatası:', err);
      throw err;
    }
  };

  return (
    <SlideContext.Provider value={{ slides, addSlide, removeSlide, setSlides }}>
      {children}
    </SlideContext.Provider>
  );
};
